import React from "react";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Tabs } from "@radix-ui/themes";

export const SettingsTabs: React.FC<{
  currentTab: string;
  setCurrentTab: React.Dispatch<React.SetStateAction<string>>;
  setCurrentChildTab: React.Dispatch<React.SetStateAction<string>>;
  title: string;
  tabs: string[];
  mobileUi?: boolean;
}> = ({
  currentTab,
  setCurrentTab,
  setCurrentChildTab,
  title,
  mobileUi,
  tabs,
}) => {
  const currentUser = useCurrentUserProfile((s) => s.user);

  return (
    <Tabs.List mb="2">
      {tabs.map((tab, i) => {
        if (tab) {
          return (
            <Tabs.Trigger
              value={tab}
              key={i}
              onClick={() => {
                setCurrentChildTab("");
                setCurrentTab(tab);
                window.scrollTo({
                  top: 0,
                });
              }}
              className={currentTab === tab ? "active" : ""}
            >
              {tab}
            </Tabs.Trigger>
          );
        }
      })}
    </Tabs.List>
  );
};
